import { render } from "./VideosPage.vue?vue&type=template&id=1a9537fa&scoped=true"
import script from "./VideosPage.vue?vue&type=script&lang=js"
export * from "./VideosPage.vue?vue&type=script&lang=js"

import "./VideosPage.vue?vue&type=style&index=0&id=1a9537fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9537fa"]])

export default __exports__